import React from 'react';

import { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { useParams } from 'react-router-dom';
import ImageLightbox from '../components/ImageLightbox';

const ProductView = () => {
    const { categoryPath, productId } = useParams();

    const [products, setProducts] = useState([]);
    const [lightboxImage, setLightboxImage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `${process.env.REACT_APP_BACKEND_API}/section/${categoryPath}/${productId}`;

                const response = await fetch(url, {
                    method: "GET",
                    mode: 'cors'
                });
                const data = await response.json();
                setProducts(data.products);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [categoryPath, productId]);

    return (
        <>
            <section className="women-banner spad">
                <Container fluid>
                    <Row className="row-cols-3=auto">
                        <Col>
                            <div className="product-card">
                                {products.length ? products.map((product) => (
                                    <div key={product.id} className="product-item">
                                        <div className="pi-pic" onClick={() => setLightboxImage(`${process.env.REACT_APP_IMAGE_URL}/${product.id}.jpeg`)}>
                                            <img 
                                                src={`${process.env.REACT_APP_IMAGE_URL}/${product.id}.jpeg`}
                                                alt={product.name}
                                                style={{ width: '100%', height: 'auto', display: 'block' }}
                                            />
                                        </div>
                                        <div className="pi-text">
                                            <div className="catagory-name">{product.category}</div>
                                            <h5>{product.name}</h5>
                                            <div className="product-price">
                                                R$ {product.price.toFixed(2)}
                                            </div>
                                        </div>

                                        {/* WhatsApp Button */}
                                            <a
                                                href={`https://wa.me/${process.env.REACT_APP_WHATSUP_NUMBER}?text=${encodeURIComponent(
                                                    `Esta peça esta disponível ?\n${product.name}\nR$ ${product.price.toFixed(2)}\n${window.location.origin}/${product.category}?p=${product.id}`
                                                )}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-success mt-2"
                                            >
                                                Fale com a Val!
                                            </a>                                    
                                    </div>
                                )) :
                                    <ReactLoading id="loading" type={'bubbles'} color={'#000000'} height={50} width={50} />
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <ImageLightbox 
                imageUrl={lightboxImage} 
                isOpen={!!lightboxImage} 
                onClose={() => setLightboxImage(null)} 
            />
        </>
    );
};

export default ProductView;